<template>
  <div class="tfl top-navigation">
    <!--顶部-->
    <div class="tfl-top" id="tfl-top">
      <ul class="top-ul">
        <li
          class="top-li"
          v-for="item in topList"
          :key="item.id"
          @click="goMenu(item)"
        >
          <img :src="item.src" />
          <a>{{ item.text }}</a>
        </li>
      </ul>
    </div>
    <!--导航-->
    <div class="tfl-navigation">
      <div class="navigation-content display-flex">
        <div class="navigation-logo">
          <img :src="logo" />
        </div>
        <div class="navigation-menu">
          <ul class="menu-ul">
            <li class="menu-li" v-for="item in navigationList" :key="item.id">
              <span class="menu-span" @click="goMenu(item)">{{
                item.text
              }}</span>
              <ul
                class="menu-children"
                :class="{
                  'not-solution': item.id !== 'Solution',
                  solution: item.id === 'Solution',
                }"
                v-if="item.children && childrenShow"
              >
                <li
                  class="children-li"
                  v-for="nav in item.children"
                  :key="nav.id"
                >
                  <div v-if="item.id === 'Solution'">
                    <span class="solution-span">{{ nav.text }}</span>
                    <ul class="solution-ul">
                      <li
                        v-for="el in nav.children"
                        :key="el.id"
                        @click="goMenu(el)"
                      >
                        {{ el.text }}
                      </li>
                    </ul>
                  </div>
                  <!-- <a v-else-if="item.id === 'Address'" :href="nav.href">{{ nav.text }}</a> -->
                  <span
                    v-else-if="item.id === 'Address'"
                    @click="changeLang(nav)"
                    >{{ nav.text }}</span
                  >
                  <span class="not-solution-span" v-else @click="goMenu(nav)">{{
                    nav.text
                  }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--图片-->
    <div class="tfl-banner" v-if="backImg">
      <img :src="backImg" />
    </div>
    <!--标题栏-->
    <div class="division" v-if="title">
      <div class="division-inner display-flex">
        <span style="cursor: pointer" @click="goHome()">{{
          $t("About.home")
        }}</span>
        <b style="color: #fff">&nbsp;>>&nbsp;</b>
        <div class="dynamic-title" v-html="title"></div>
      </div>
    </div>
    <!-- 回到顶部 -->
    <div
      class="backtop"
      @click="backTop()"
      :title="$t('About.backTop')"
      v-show="isShowBackTopBtn"
    >
      <img :src="backtop" />
    </div>
  </div>
</template>
<script>
import { topList, navigationList } from "../../config/dictionary";
import logo from "@/assets/img/top/logo.png";
import backtop from "@/assets/img/top/backtop.png";
import { pageName as pageNameZh } from "@/i18n/langs/zh";
import { pageName as pageNameEn } from "@/i18n/langs/en";
export default {
  name: "",
  props: {
    pageParam: {
      type: Object,
      default: null,
    },
    backImg: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      logo,
      backtop,
      // backImg: null,
      title: null,
      childrenShow: true,
      isShowBackTopBtn: false,
      wheelName: navigator.userAgent.toUpperCase().includes("Firefox")
        ? "DOMMouseScroll"
        : "mousewheel",
    };
  },
  methods: {
    goHome() {
      this.$router.push({
        path: "/",
      });
    },
    backTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      let timer = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            500;
        if (top <= 0) {
          this.isShowBackTopBtn = false;
          clearInterval(timer);
        }
      }, 10);
    },
    goMenu(item) {
      if (this.$route.path.includes("/Case") && item.href === "/Case") {
        // if (this.$route.path.split("/")[2] === item.id) return;
        this.$route.meta.scroll = true;
        this.$emit("case-change", item.id);
        this.childrenShow = false;
        setTimeout(() => {
          this.childrenShow = true;
        }, 10);
      }
      const tempRouter =
        item.href === "/Case"
          ? { path: `${item.href}/${item.id}` }
          : { path: item.href };
      this.$router.push(tempRouter);
    },
    changeLang(item) {
      if (item.id === "Address-China") this.$t.locale = "zh";
      else this.$t.locale = "en";
      localStorage.setItem("tfl-lang", this.$t.locale);
      window.location.reload();
    },
    getScrollTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      this.isShowBackTopBtn = top > 0;
    },
    back(level) {
      if (!level) return;
      this.$router.back(level);
    },
  },

  created() {
    if (this.pageParam) {
      if (!this.backImg) {
        this.pageParam.pageCode &&
          (this.backImg = require(`@/assets/img/${this.pageParam.pageCode}/banner.png`));
      }

      let pageName = this.pageParam.pageName;
      if (pageName) {
        let template = "";
        console.log(pageName);
        pageName.forEach((n, idx) => {
          if (this.$store.state.dynamic.lang === "en") {
            const index = Object.values(pageNameZh).findIndex(
              (item) => item === n
            );
            if (index > -1) {
              const key = Object.keys(pageNameZh)[index];
              n = pageNameEn[key];
            }
          }
          template += `<span style="font-size: 14px;font-family: PingFang;font-weight: 400;color: #ffffff; cursor: ${
            pageName.length - 1 - idx === 0 ? "default" : "pointer"
          }" onclick="back(${pageName.length - 1 - idx})">${n}</span>${
            idx + 1 === pageName.length
              ? ""
              : "<b style='color: #ffffff;'>&nbsp;>>&nbsp;</b>"
          }`;
        });
        this.title = template;
      }
      window.back = this.back;
    }
    this.topList = JSON.parse(JSON.stringify(topList));
    this.navigationList = JSON.parse(JSON.stringify(navigationList));
    window.addEventListener(this.wheelName, this.getScrollTop);
  },
  destroyed() {
    window.removeEventListener(this.wheelName, this.getScrollTop);
  },
};
</script>
<style lang="less" scoped>
.tfl {
  .tfl-top {
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    // width: 100%;
    // height: 40px;
    background-color: #1e1e1e;
    z-index: 999;

    .top-ul {
      display: flex;
      flex-direction: column;
      background-color: #1e1e1e;
      align-items: center;
      justify-content: flex-end;
      // height: 100%;
      // width: 1200px;
      // margin: 0 auto;
      box-sizing: border-box;

      .top-li {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        padding: 16px 18px;
        cursor: pointer;

        &:nth-child(n + 2) {
          margin-top: 8px;
        }

        &:hover {
          background-color: #fed209;
        }

        img {
          width: 14px;
          height: 18px;
          color: #ffffff;
          margin-right: 4px;
        }

        a {
          height: 12px;
          font-size: 12px;
          font-family: PingFang;
          font-weight: 400;
          color: #ffffff;
          line-height: 12px;
        }
      }
    }
  }

  .tfl-navigation {
    width: 100%;
    height: 120px;
    box-sizing: border-box;
    background: url("~@/assets/img/Top/menu-bgc.png") no-repeat 100% 100%;

    .navigation-content {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      justify-content: space-between;
      box-sizing: border-box;
    }

    .navigation-logo {
      width: 209px;
      height: 42px;

      img {
        width: 100%;
        height: 100%;
        background-size: cover;
      }
    }

    .navigation-menu {
      height: 100%;

      .menu-ul {
        display: flex;
        align-items: center;
        height: 100%;

        .menu-li {
          height: 16px;
          line-height: 16px;
          margin-left: 47px;
          position: relative;
          flex-shrink: 0;

          &::after {
            position: absolute;
            left: 0;
            top: 15;
            content: "";
            height: 15px;
            width: 100%;
            cursor: pointer;
            background-color: transparent;
            display: none;
          }

          &:hover {
            &::after {
              display: block;
            }

            .menu-span::after {
              display: block;
            }

            .menu-children {
              display: block;

              &.solution {
                display: flex;
              }
            }
          }

          &:first-child {
            margin-left: 0;
          }

          .menu-span {
            display: inline-block;
            height: 16px;
            line-height: 16px;
            font-size: 16px;
            font-family: PingFang;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
            position: relative;

            &::after {
              position: absolute;
              left: 0;
              bottom: -12px;
              display: none;
              content: "";
              width: 100%;
              height: 3px;
              background: #fed209;
            }
          }

          .menu-children {
            position: absolute;
            top: 30px;
            left: 0;
            // width: 139px;
            background: #333333;
            display: none;
            z-index: 99;

            &.not-solution > .children-li {
              flex-shrink: 0;
              height: 16px;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #ffffff;
              height: 32px;
              line-height: 32px;
              box-sizing: border-box;
              padding: 0 10px;
              // overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;

              &:hover {
                .not-solution-span,
                a {
                  color: #e2211c;
                  background: #2a2a2a;
                }
              }
            }

            &.solution {
              width: 496px;
              box-sizing: border-box;
              padding: 12px 22px 9px;
              justify-content: space-between;
              left: 50%;
              transform: translateX(-50%);

              & > .children-li {
                flex-shrink: 0;

                & .solution-span {
                  height: 17px;
                  line-height: 17px;
                  font-size: 18px;
                  font-family: PingFang SC;
                  font-weight: 800;
                  color: #fefefe;
                }

                .solution-ul {
                  margin-top: 18px;

                  li {
                    flex-shrink: 0;
                    height: 16px;
                    line-height: 16px;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    padding-top: 16px;
                    cursor: pointer;

                    &:hover {
                      color: #e2211c;
                    }

                    &:first-child {
                      padding-top: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .tfl-banner {
    width: 100%;

    // height: 456px;
    img {
      width: 100%;
      background-size: cover;
    }
  }

  /***分割*/
  .division {
    width: 100%;
    height: 52px;
    line-height: 52px;
    box-sizing: border-box;
    background: #1e1e1e;
    justify-content: flex-start;

    .division-inner {
      width: 1200px;
      margin: 0 auto;
      background: #1e1e1e;
      justify-content: flex-start;

      span {
        font-size: 14px;
        font-family: PingFang;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .backtop {
    width: 30px;
    height: 30px;
    position: fixed;
    bottom: 30px;
    right: 30px;
    color: #fff;
    background-color: #9a9099;
    padding: 10px;
    cursor: pointer;
    z-index: 999;

    img {
      width: 100%;
      height: 100%;
      background-size: contain;
    }
  }
}

@media screen and (max-width: 1400px) {
  .tfl .tfl-top .top-ul,
  .tfl-navigation .navigation-content {
    padding: 0 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopNavigation.vue